import type { LookoRouteObject } from '../LookoRouteObject';
import { uploadMap } from '../uploadMaps';

// 사용자 작업
const taskRoutes: LookoRouteObject[] = [
  {
    path: uploadMap['task-list'].path,
    async lazy() {
      const { default: Page } = await import('@/app/upload/task-list/TaskListPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: uploadMap.task.path,
    async lazy() {
      const { default: Page } = await import('@/app/upload/task/TaskItemListPage');
      return {
        Component: Page,
      };
    },
  },
];

export default taskRoutes;
